import { Injectable } from "@angular/core";
import { StaffRequirementWorkflowService } from "lib-klab-sdks";
import { map, Observable } from "rxjs";
import { RequirementWorkflowPort } from "../../../app/ports/requirement/requirement-workflow.port";
import { RequirementRecord } from "../../../domain/models/requirement/requirement.model";
import { RequirementApproval, RequirementDecisionRequest, RequirementHistory, RequirementRequiredDecisionRequest } from "../../../domain/models/requirement/requirement-workflow.model";
import { mapRequirementRecord } from "../../mappers/requirement/requirement.mapper";
import { mapRequirementApproval, mapRequirementHistory } from "../../mappers/requirement/requirement-workflow.mapper";

@Injectable({ providedIn: "root" })
export class RequirementWorkflowPortAdapter implements RequirementWorkflowPort {
  constructor(private readonly api: StaffRequirementWorkflowService) {}

  submit(id: number): Observable<RequirementRecord> {
    return this.api.submit(id).pipe(map(({ data }) => mapRequirementRecord(data)));
  }

  resubmit(id: number): Observable<RequirementRecord> {
    return this.api.resubmit(id).pipe(map(({ data }) => mapRequirementRecord(data)));
  }

  approve(id: number, request?: RequirementDecisionRequest): Observable<RequirementRecord> {
    return this.api.approve(id, request).pipe(map(({ data }) => mapRequirementRecord(data)));
  }

  observe(id: number, request: RequirementRequiredDecisionRequest): Observable<RequirementRecord> {
    return this.api.observe(id, request).pipe(map(({ data }) => mapRequirementRecord(data)));
  }

  reject(id: number, request: RequirementRequiredDecisionRequest): Observable<RequirementRecord> {
    return this.api.reject(id, request).pipe(map(({ data }) => mapRequirementRecord(data)));
  }

  cancel(id: number, request?: RequirementDecisionRequest): Observable<RequirementRecord> {
    return this.api.cancel(id, request).pipe(map(({ data }) => mapRequirementRecord(data)));
  }

  listApprovals(id: number): Observable<readonly RequirementApproval[]> {
    return this.api.listApprovals(id).pipe(map(({ data }) => data.map(mapRequirementApproval)));
  }

  listHistory(id: number): Observable<readonly RequirementHistory[]> {
    return this.api.listHistory(id).pipe(map(({ data }) => data.map(mapRequirementHistory)));
  }
}
